import React from "react";

const variantClasses = {
  primary:
    "bg-[#4f46e5] text-white shadow-[0_10px_20px_rgba(79,70,229,0.25)] hover:bg-[#4338ca] focus-visible:outline-[#4f46e5]",
  secondary:
    "bg-white dark:bg-slate-700 text-slate-700 dark:text-slate-200 border border-slate-200 dark:border-slate-600 hover:border-slate-300 dark:hover:border-slate-500 hover:text-slate-900 dark:hover:text-slate-100 focus-visible:outline-slate-400",
  ghost:
    "bg-transparent text-slate-600 dark:text-slate-400 hover:text-slate-900 dark:hover:text-slate-100",
  danger:
    "bg-rose-600 text-white shadow-[0_10px_20px_rgba(225,29,72,0.25)] hover:bg-rose-700 focus-visible:outline-rose-600",
  "pos-primary":
    "rounded-xl bg-gradient-to-r from-indigo-600 to-purple-600 dark:from-indigo-500 dark:to-purple-500 text-white font-bold shadow-lg hover:shadow-xl hover:from-indigo-700 hover:to-purple-700 dark:hover:from-indigo-600 dark:hover:to-purple-600 active:scale-95 transition-all duration-200",
  "pos-secondary":
    "rounded-xl bg-slate-100 dark:bg-slate-700 text-slate-900 dark:text-slate-100 font-semibold hover:bg-slate-200 dark:hover:bg-slate-600 active:scale-95 transition-all duration-200 shadow-md hover:shadow-lg",
  "pos-success":
    "rounded-xl bg-gradient-to-r from-emerald-500 to-emerald-600 dark:from-emerald-400 dark:to-emerald-500 text-white font-bold shadow-lg hover:shadow-xl hover:from-emerald-600 hover:to-emerald-700 active:scale-95 transition-all duration-200",
  "pos-danger":
    "rounded-xl bg-gradient-to-r from-rose-500 to-rose-600 dark:from-rose-400 dark:to-rose-500 text-white font-bold shadow-lg hover:shadow-xl hover:from-rose-600 hover:to-rose-700 active:scale-95 transition-all duration-200",
};

const sizeClasses = {
  sm: "h-9 px-3 text-sm",
  md: "h-11 px-4 text-sm",
  lg: "h-12 px-6 text-base",
};

const Button = ({
  children,
  className = "",
  type = "button",
  variant = "primary",
  size = "lg",
  ...props
}) => {
  return (
    <button
      type={type}
      className={[
        "rounded-lg font-semibold transition focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2",
        "disabled:cursor-not-allowed disabled:opacity-50 disabled:shadow-none",
        variantClasses[variant] || variantClasses.primary,
        sizeClasses[size] || sizeClasses.lg,
        className,
      ]
        .filter(Boolean)
        .join(" ")}
      {...props}
    >
      {children}
    </button>
  );
};

export default Button;
